export default [
  {
    id: 0,
    title: "Design or provide artwork",
    content: [
      "Send us your custom artwork or use one of our talented designers to come up with a fresh design (for free!)"
    ],
    image: "../../images/process/design.png",
    shortTitle: "Design",
    questions: [
      {
        title: "What can I get designed?",
        content:
          "Pretty much anything! Our professional designers can create all promotional materials, including apparel, jerseys, flags, and accessories."
      },
      {
        title: "How much does it cost?",
        content:
          "Our designs are always free, and our designers are always willing to make adjustments until we get your design just the way you want it!"
      },
      {
        title: "How long does it take?",
        content:
          "We pride ourselves on our ability to iterate quickly, with each design request taking no more than 24-hours to complete."
      }
    ]
  },
  {
    id: 1,
    title: "Online order",
    content: [
      "Once your happy with your design, we can begin the ordering process. We build your group a Custom Store so you can offer your members a seamless ordering experience. Garments are priced based on how many your group orders."
    ],
    image: "../../images/process/order.png",
    shortTitle: "Order",
    questions: [
      {
        title: "What forms of payment do you accept?",
        content:
          "We are able to accept most forms of payment, including credit/debit card, check, cash, and Venmo."
      },
      {
        title: "What's a Custom Store?",
        content:
          "A custom store allows each member in your organization to shop and pay for products individually. This means that you don't need to waste time tallying orders and collecting payment."
      }
    ]
  },
  {
    id: 2,
    title: "Garments are shipped",
    content: [
      "Most garments can be printed in 10 days or less. All of our Greek products are Official Licensed Products."
    ],
    image: "../../images/process/affinity.png",
    shortTitle: "Impress",
    questions: [
      {
        title: "Do you offer returns?",
        content:
          "Because all of our products are custom-made for you, we do not accept returns. However, we pride ourselves on an exceptional experience. So, if we ever make a mistake we will always go the extra-mile to fix it. "
      },
      {
        title: "How are group orders shipped?",
        content:
          "We offer a variety of shipping methods to meet your needs. Typically, group orders are shipped together to a single address to be distributed."
      }
    ]
  }
];
